import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Image } from '../Image';
import { OnScrollWrapper } from '../UtilityWrappers';
import { isFieldValid } from '../../utils/validation';
import media from '../../utils/media';
const GraphicContainer = styled.div `
  background-color: ${({ theme }) => theme.primaryWhite};
  display: flex;
  justify-content: center;
`;
const StyledImage = styled(Image) `
  max-width: 540px;
  width: 100%;
  height: 340px;

  ${media.mobile} {
    height: 170px;
    width: 270px;
  }
`;
export const ImageGraphic = ({ fields }) => {
    const [shouldAnimate, setShouldAnimate] = useState(false);
    const [imgObj, setImgObj] = useState(undefined);
    if (!fields) {
        return null;
    }
    const { graphicThumbnail } = fields;
    if (!isFieldValid(graphicThumbnail, 'src')) {
        return null;
    }
    else if (!imgObj) {
        setImgObj(graphicThumbnail);
    }
    useEffect(() => {
        if (typeof window !== 'undefined' && shouldAnimate && imgObj) {
            let img = window.document.createElement('img');
            img.src = `${imgObj.value.src}?p` + Math.random(); // creates random number to concatonate to image src
            // when we set img.src, we are reloading the image/gif
            img.onload = () => {
                const updatedImage = Object.assign({}, imgObj);
                updatedImage.value.src = img.src;
                setImgObj(updatedImage);
            };
        }
    }, [shouldAnimate]);
    return (React.createElement(OnScrollWrapper, { onVisibilityChange: setShouldAnimate },
        React.createElement(GraphicContainer, null, imgObj && React.createElement(StyledImage, { field: imgObj }))));
};
